import { SVGProps } from 'react'

const ActiveBoxIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M5.33359 14.5C5.09978 14.4998 4.87013 14.438 4.6677 14.321C4.46527 14.204 4.29717 14.0358 4.18026 13.8333L1.51359 9.16667C1.39657 8.96397 1.33496 8.73405 1.33496 8.5C1.33496 8.26595 1.39657 8.03603 1.51359 7.83333L4.18026 3.16667C4.29717 2.96418 4.46527 2.79599 4.6677 2.67897C4.87013 2.56196 5.09978 2.50024 5.33359 2.5H10.6669C10.9007 2.50024 11.1304 2.56196 11.3328 2.67897C11.5353 2.79599 11.7034 2.96418 11.8203 3.16667L14.4869 7.83333C14.604 8.03603 14.6656 8.26595 14.6656 8.5C14.6656 8.73405 14.604 8.96397 14.4869 9.16667L11.8203 13.8333C11.7034 14.0358 11.5353 14.204 11.3328 14.321C11.1304 14.438 10.9007 14.4998 10.6669 14.5H5.33359Z'
                stroke='#349FFD'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.66699 2.69971L8.00033 8.49971L4.66699 14.2997'
                stroke='#349FFD'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.6667 8.5H8'
                stroke='#349FFD'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default ActiveBoxIcon
